module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0022.jpg?v=0fd6a1ac";